import React, {PureComponent} from 'react';
import _, { isEqual } from 'lodash';
import $ from 'jquery';
import * as HTML_RENDITION from '../utils/general/general';
import {connect} from 'react-redux';
import {IReducerState} from '../states/renditionStates';
import * as deviceInfoService from '../utils/general/deviceInfoService';
import StyleTransfrom from '../utils/general/styleTransform';
import * as environmentService from '../utils/general/environmentService';
import FigureGalleryDom from '../mainpage/figureGallery';
import InfographicTemplate from './infographicTemplate';
import UserAgentUtils from '../utils/general/userAgentUtils';
// import {ElevateZoom} from '../utils/general/elevatezoom';
import {switchPage} from "../utils/api/pageControl";
import ModalPopup from '../modalrelated/modalPopup';
import NormalScreenPopup from '../modalrelated/normalScreenPopup';
import ImageEnlargePopup from '../modalrelated/imageEnlargePopup';
import commonStore from '../store/commonStore.js';
import * as commonStateAction from '../actions/commonStateAction';
import ErrorBoundary from '../utils/api/errorBoundary';
import LazyLoad from 'react-lazyload';
import { RenditionLoadable } from '../utils/general/LoadableRelated';
import { isFigureGalleryPopup } from '../utils/general/general';

const productType = window.HTML_RENDITION.initialData.productType;
const themeFromURL = "";
// _.get(
//     _.get(_.get(window, "location.href", "").split("?"), "[1]", "").split("="),
//       "[1]",
//       ""
// );
const showOldBranding = themeFromURL === "" ? (_.includes(["globalinsights","gps"],productType) ||
    window.HTML_RENDITION.initialData.enable2023rebranding === 'false') : themeFromURL === "old" ? true : false;

// importtant!!! this file use old rendition drawing-directive.js but interaction should be added in future!

interface IDrawingTemplateProps {
    source: any;
    screenType: string;
    imageSizeCategory: string;
    initialData: any;
    docHeaderJsonData: any;
    figureGalleryData: any;
    altText: any;
    isFigure?: boolean;
    isDetached?: boolean;
}

interface IDrawingTemplateStatus {
    finalElement: any;
    tableElement: any;
    modalStatus: boolean; // Improtant!!! each modal should have a unique status! don't use redux in this value!
    modalTitle: any;
    modalSource: any;
}

export class DrawingTemplate extends PureComponent<IDrawingTemplateProps, IDrawingTemplateStatus> {
    public drawingRef: any = React.createRef();
    public imgRef: any = React.createRef();
    public altTextStr: any = '';
    public isArrowImage: boolean = false;

    constructor(props: IDrawingTemplateProps) {
        super(props);
        this.state = {
            finalElement: null,
            tableElement: null,
            modalStatus: false,
            modalTitle: null,
            modalSource: null,
        };
    }

    public componentDidMount() {
        this.buildDOM();
        $(window).on('resize', _.debounce(_.bind(this.handleReize, this), 500));
    }

    public componentWillUnmount() {
        $(window).off('resize', _.debounce(_.bind(this.handleReize, this), 500));
    }

    public handleReize() {
        commonStore.dispatch(commonStateAction.getScreenType());
        this.buildDOM();
    }

    public buildDOM() {
        const {source} = this.props;

        if (!source && !this.drawingRef.current) {
            return null;
        }

        const element = $(this.drawingRef.current);
        typeof (source.isEquation) !== 'undefined' ? source.isEquation = HTML_RENDITION.parseToBoolean(source.isEquation) : source.isEquation = false;
        const model = source;

        const isFigureGalleryImage = (element.parents('.figure-gallery-container').length > 0);
        const isImageInsideTable = (element.parents('td').length > 0);
        const isFigureGalleryImageInsidePage = (element.parents('.CIRFigure').length > 0);
        const isDisclosureImage = (element.parents('.disclosure-section').length > 0);
        const isSlideImage = (element.parents('.slideShape').length > 0);
        const isHeaderOrFooterImage = (element.parents('.wordHeaderOrFooter').length > 0);
        const isFullSpanImage = (element.parents('.fullSpanImage').length > 0);
        const imageSize = source[this.props.imageSizeCategory] ? this.props.imageSizeCategory : 'default';
        const isNonResearchIconImage = (Number(source[imageSize].height.split('pt')[0]) < 7);  // The height of non research link icon returned from backend is 6.75pt

        // fix the jira C150113-28508 Svg images display in small size on IE 11.0.9600.19431 on Win 7
        source.isSvgImage = false;
        if (!!source.imageName) {
            source.isSvgImage = ("svg" === source.imageName.substr(source.imageName.lastIndexOf('.') + 1));
        }

        const showBlockImageForFAVEMSWORD = this.props.initialData.isFAVE && this.props.docHeaderJsonData.metadata.docFileType == 'MSWORD';
        const spanStyle = {
            display: source.isSvgImage ? 'block' : showBlockImageForFAVEMSWORD ? 'block' : 'inline-block'
        };

        let width = 'auto';
        let height = 'auto';
        const figureGalleryImageWidth:any = '';

        const isStaticImage = () => {
            if (model != null && model["imageName"] && (model["imageName"].indexOf("/img/") > -1)) {
                return true;
            }
            return false;
        };

        const getHref = function (link: string) {
            return HTML_RENDITION.isCompendiumProduct() ? HTML_RENDITION.addParentDocDataParam(link) : link;
        };

        const getImageUrl = (imageType: string, imageSizeCategory: string) => {
            if (source.isFAVEOrCGI) {
                // Using for FAVE docFileType is HTML, when click open FG, will enter this if block.
                const faveHTMLImage = (deviceInfoService.isIE() && !isFigureGalleryImage) ? `ieImages/${source[imageSizeCategory].filename}` : `fgImages/${source[imageSizeCategory].filename}`;
                return (
                    (_.startsWith(source[imageSizeCategory].filename, 'http') || _.isEmpty(source[imageSizeCategory].filename)) ?
                        source[imageSizeCategory].filename :
                        environmentService.getImagePath(faveHTMLImage)
                );
            }
            let imageName = source[imageSizeCategory].mainDocFilename;
            if (this.props.initialData.isFAVEOrCGI && !_.startsWith(imageName, '/')) {
                return getFAVEImageUrl();
            }
            if (imageType == 'fg') {
                imageName = source[imageSizeCategory].fgFilename;
            } else if (imageType == 'enlarge') {
                imageName = source[imageSizeCategory].enlargeFilename;
            }
            if ((!deviceInfoService.isIE() && imageSizeCategory != "small") || isFullSpanImage) {
                imageName = source[imageSizeCategory].filename;
            }
            if ((deviceInfoService.isIE()) && !isFullSpanImage) {
                imageName = source[imageSizeCategory].enlargeFilename;

                if (_.isUndefined(imageName) || !_.isNull(imageName)) {
                    imageName = source[imageSizeCategory].filename;
                }
            }
            if (isFigureGalleryImage) {
                imageName = source[imageSizeCategory].filename;
            }
            if (imageName.toLowerCase().indexOf('arrow') > -1) {
                this.isArrowImage = true;
            }
            return environmentService.getImagePath(imageName);
        };

        const getFAVEImageUrl = () => {
            let imageName = source.imageName;
            if (imageName == '') {
                // The base64 image is a 1px*1px gif image
                imageName = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                return imageName;
            }
            if (_.startsWith(imageName, 'http')) {
                return imageName;
            }
            imageName = deviceInfoService.isIE() && !isFigureGalleryImage ? `ieImages/${imageName}` : `fgImages/${imageName}`;
            return environmentService.getImagePath(imageName);
        };

        if (isFigureGalleryImage) {
            width = '100%';
            $.extend(spanStyle, {
                display: 'block'
            });
        } else if (isDisclosureImage) {
            width = '100%';
            $.extend(spanStyle, {
                display: 'block'
            });
        } else if (isHeaderOrFooterImage) {
            width = source['default'].WordWidth;
        } else if (isImageInsideTable || isFullSpanImage) {
            width = '100%';
        } else if (source.isEquation) {
            height = model[imageSize].height;
            $.extend(spanStyle, {
                display: "inline"
            });
        } else if (isSlideImage) {
            width = deviceInfoService.isIE() ? 'auto' : '100%';
            height = deviceInfoService.isIE() ? 'auto' : '100%';
            $.extend(spanStyle, {
                width: '100%',
                height: '100%'
            });
        } else if (isNonResearchIconImage) {
            $.extend(spanStyle, {
                clear: 'both'
            });
        } else {
            $.extend(spanStyle, {
                display: 'block',
                clear: 'both'
            });
        }

        // Initial style
        const style = {
            width,
            height,
            maxWidth: (isFigureGalleryImage ? figureGalleryImageWidth : source[imageSize].width) + 'px',
        };

        let maxWidthStyle: string = '';// ' style="max-width:' + (isFigureGalleryImage ? figureGalleryImageWidth : source[this.props.imageSizeCategory].width) + 'px"';

        // No max width
        if (HTML_RENDITION.isPresentation()
            || isFullSpanImage) {
            maxWidthStyle = '';
        }

        // Just for Landscape
        if (this.props.initialData.productType == 'landscape') {
            maxWidthStyle = ' style="max-width:' + source[imageSize].WordWidth + '"';
            $.extend(style, {
                width: isHeaderOrFooterImage ? source['default'].WordWidth : 'auto',
            });
        }

        if (model && model[imageSize]) {

            let isImageLink = false;
            let imgClickEvent = '';
            let spanClass = 'x-rsch-drawing-span';
            if (source.format
                && source.format['class']
                && !_.isUndefined(source.format['class'])) {
                spanClass += ' ';
                spanClass += source.format['class'];
            }

            // Image is a link, so it can not be enlarged. We need to take it to the appropriate link
            if (!_.isUndefined(model[imageSize].href)
                && model[imageSize].href !== ""
                && model[imageSize].href !== null) {
                isImageLink = true;
            } else if (isStaticImage() || source.isEquation) {
                $.extend(style, {
                    cursor: 'default'
                });
            }
            // Image is not an link, so it can be enlarged
            else {
                imgClickEvent = this.props.initialData.compId == '11' ? '' : 'true';
            }

            // No Enlarge feature on PPT / Landscape products
            if (HTML_RENDITION.isPresentation()) {
                imgClickEvent = '';
            }

            if (isFigureGalleryImageInsidePage) {
                spanClass += ' figure-gallery-image-inside-page';
            }

            $.extend(spanStyle, {
                position: "relative",
                overflowX: "auto",
                overflowY: "hidden",
                margin: "0 !important"
            });

            let image = getImageUrl('main', imageSize);
            // The base64 image is a 1px*1px gif image
            image = _.isEmpty(image) ? 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' : image;

            //disable zoom function
            
            // if (isFigureGalleryImageInsidePage && /* window.HTML_RENDITION.enableMagnifier === true && */ !UserAgentUtils.isMobile.any()) {
            //     /*                 const newElement: any = element;
            //                     if (!newElement){
            //                         return;
            //                     } */
            //     const $table = element.closest('table');
            //     if ((!$table.hasClass('single-magnifier-tool') && !$table.hasClass('infographic-img-table')) || window.HTML_RENDITION.initialData.isStaticHtml) {
            //         const $td = element.closest('tr').find('td');
            //         const $toolContainer = $('<div tabIndex=0 class="magnifier-tool-con"></div>');
            //         if ($td.find('.drawing-template-part').length) {
            //             $td.closest('div.tableWrapper').css('cssText', 'position: relative;padding-top:17px;');
            //             const $toolBtn = $('<span id="" class="magnifier-tool animated" title="Use your mouse scroller to zoom in and out"></span>');
            //             $toolContainer.append($toolBtn);
            //             $td.find('span.drawing-template-part').before($toolContainer);
            //             let zoomOption: any = {};
            //             try {
            //                 zoomOption = JSON.parse(this.props.initialData.zoomOption ||
            //                 `{\"lensSize\":215,
            //                     \"borderSize\":2,
            //                     \"zoomType\":\"lens\",
            //                     \"lensShape\":\"round\",
            //                     \"cursor\":\"pointer\",
            //                     \"scrollZoom\":true,
            //                     \"scrollZoomIncrement\":0.1,
            //                     \"zoomWindowWidth\":100,
            //                     \"zoomWindowHeight\":100}`);
            //             } catch (e) {
            //                 console.log(e);
            //             }
            //             const cbFun = (e: any) => {
            //                 const $renditionZoomImage = $('.rendition_zoom_image');
            //                 const $magnifierTool = $('.magnifier-tool');
            //                 const $zoomContainer = $('.zoomContainer');
            //                 if (!window.HTML_RENDITION.initZoom) {
            //                     zoomOption['exEvent'] = e;
            //                     ElevateZoom(zoomOption, $renditionZoomImage);
            //                     window.HTML_RENDITION.initZoom = true;
            //                 }
            //                 if ($magnifierTool.is('.tool-off')) {
            //                     $renditionZoomImage.data('elevateZoom').zoomEnabled = false;
            //                     $renditionZoomImage.unbind('mousewheel DOMMouseScroll MozMousePixelScroll');
            //                     $zoomContainer.hide();
            //                 } else {
            //                     $renditionZoomImage.data('elevateZoom').zoomEnabled = true;
            //                     $zoomContainer.show();
            //                 }
            //                 $magnifierTool.toggleClass('tool-off');
            //                 return false;
            //             };
            //             $toolBtn.on('click', (e) => {
            //                 cbFun(e);
            //                 e.stopPropagation();
            //             });
            //             $toolContainer.keypress((e) => {
            //                 e.stopPropagation();
            //                 const code = e.keyCode || e.which;
            //                 if (code === 13 || code === 32) cbFun(e);
            //             });
            //             if (!window.HTML_RENDITION.initZoomEvent) {
            //                 $(document).on('mouseenter', '.zoomContainer .zoomLens', function () {
            //                     $(this).data('image').$elem.closest('tr').find('.magnifier-tool').show();
            //                 }).on('mouseleave', '.zoomContainer .zoomLens', function () {
            //                     $(this).data('image').$elem.closest('tr').find('.magnifier-tool').hide();
            //                 });
            //                 $(document).on('mouseenter', '.rendition_zoom_image', function () {
            //                     $('.magnifier-tool').is('.tool-off') && $('.zoomContainer').show();
            //                 });
            //                 window.HTML_RENDITION.initZoomEvent = true;
            //             }
            //         } else {
            //             element.parent('span').before($toolContainer);
            //         }
            //         $table.addClass('single-magnifier-tool');
            //     }
            // }

            const altText = this.altTextStr || this.props.altText || HTML_RENDITION.buildAdaAltText('','') || (source['default'].alt ? source['default'].alt : 'drawing image');
            let imageTemplateString = null;
            if (this.props.initialData.docFileType == 'HTML') {
                imageTemplateString = (
                    <span className={spanClass} style={StyleTransfrom(spanStyle)}>
                        <img tabIndex={0} style={StyleTransfrom(style)} className="rendition_zoom_image x-rsch-drawing imageWrapper"
                             src={image} alt={altText} aria-label={altText} />
                    </span>
                );
            }
            if (!isImageLink) {
                const detached = this.props.isDetached || false;
                if (spanClass.indexOf('InfographicConversionFlag') >= 0 && (detached || !this.props.isFigure)) {
                    imageTemplateString = (<span className={spanClass}
                    style={StyleTransfrom("display:block;overflow-x:auto;overflow-y:hidden;")}>
                        <ErrorBoundary><InfographicTemplate source={source} /></ErrorBoundary>
                    </span>);
                } else {
                    const imageLoadFun = (img: any) => {
                        const imgSrc = $(img.currentTarget).attr('src') || '';
                        const newImg = new Image();
                        newImg.src = imgSrc;
                        newImg.onload = () => {
                            let imgWidth = 0;
                            document.body.appendChild(newImg);
                            imgWidth = newImg.offsetWidth;

                            document.body.removeChild(newImg);

                            const leftBarWidth = $('#floatLeftPartMenu').width() || 0;
                            let renditionContentWidth = 0;
                            let wrapperWidth = 0;
                            const liPadding = 45;
                            let liWidth = 0;
                            let maxWidth: any = '';
                            let originalMaxWidth = 0;

                            if ($('#modal-root>div').length || $('.ReactModalPortal>div').length) {    // modify image in FG
                                renditionContentWidth = $('#mainView > .container').width() || 0;
                                wrapperWidth = renditionContentWidth - leftBarWidth;
                                const isSingleImg = $(this.imgRef.current).parents('.figure-gallery-container').find('.single-img').length;
                                const singleLiWidth = wrapperWidth - liPadding - 20;
                                liWidth = isSingleImg ? singleLiWidth : ((wrapperWidth / 2) - liPadding);

                                if (imgWidth < liWidth) {
                                    maxWidth = imgWidth;
                                } else {
                                    maxWidth = liWidth;
                                }
                                if (maxWidth < 640) {
                                    maxWidth = 640;
                                }

                                const carouselItem: any = $(this.imgRef.current).parents('.carousel-item');

                                const carouselItemWidth: number =
                                    (carouselItem.attr('class')?.indexOf('active') > -1) ?
                                        (carouselItem.width() || 0) :
                                        (carouselItem.siblings('.active').width() || 0);

                                originalMaxWidth = isSingleImg ? (carouselItemWidth - 20) : (carouselItemWidth / 2);

                                this.handleClassList(originalMaxWidth, imgWidth, this.imgRef.current);
                            }
                            if ($('.detach-figure-gallery-container').length) {   // modify image in detach popup window
                                renditionContentWidth = $('.detach-figure-gallery-container').width() || 0;
                                wrapperWidth = renditionContentWidth;
                                maxWidth = imgWidth;
                                if (maxWidth < 640) {
                                    maxWidth = 640;
                                }
                                originalMaxWidth = $('.detach-figure-gallery-container').width() || 0;

                                this.handleClassList(originalMaxWidth, imgWidth, this.imgRef.current);
                            }

                            if (this.imgRef.current) {
                                if (imgWidth > source[imageSize].width) {        // if image's actual width is bigger than the maxWidth from json file, then use value of 100% for its maxWidth
                                    this.imgRef.current.style.maxWidth = '100%';
                                } else {
                                    this.imgRef.current.style.maxWidth = maxWidth + 'px';
                                }
                            }
                        };
                    };

                    let imgContainer = null;
                    if (this.isArrowImage && image) {
                        const imageNamePathArr = image.split('/');
                        //  get the whole image path and split it into array, for example: ["", "rendition", "eppublic", "akpublic", "documents", "1_003", "img", "red-down-arrow.png?ts=1628842814127"]
                        const imageNameArr = imageNamePathArr && imageNamePathArr[imageNamePathArr.length - 1]?.split('.');
                        //  get the image name, for example: ["red-down-arrow", "png?ts=1628842814127"]
                        imgContainer = (
                            <img style={StyleTransfrom(style)}
                                 src={image}
                                 tabIndex={0}
                                 ref={this.imgRef}
                                 className="rendition_zoom_image x-rsch-drawing imageWrapper"
                                 alt={imageNameArr[0]} />
                        );
                    } else {
                        imgContainer = (
                            <img
                                style={StyleTransfrom(style)}
                                src={image}
                                tabIndex={0}
                                ref={this.imgRef}
                                className="rendition_zoom_image x-rsch-drawing imageWrapper"
                                onLoad={(img) => imageLoadFun(img)}
                                onClick={(e) => this.openEnlargedImage(e, imgClickEvent)}
                                onKeyPress={(e) => (e.keyCode === 13 || e.keyCode === 32 || e.which === 13 || e.which === 32) ? this.openEnlargedImage(e, imgClickEvent) : null}
                                alt={altText}
                                aria-label={altText} />
                        );
                    }

                    const ifNeedToLazyLoadImage = (spanClass.indexOf('bullBear_') > -1) || !deviceInfoService.isDeviceScreenType() || this.isArrowImage;
                    let hiddenButtonFlag = false;
                    imgContainer = ifNeedToLazyLoadImage ? imgContainer : (<LazyLoad height={200}>{imgContainer}</LazyLoad>);
                    if (spanClass.indexOf('bullBear_') > -1) {
                        hiddenButtonFlag = true;
                    }

                    imageTemplateString = (
                        <span className={spanClass} style={StyleTransfrom(spanStyle)}>
                            {imgContainer}
                            {hiddenButtonFlag &&
                                (
                                    <button className="table_hidden_button" onKeyPress={(e) => e.keyCode === 13 || e.keyCode === 32 || e.which === 13 || e.which === 32 ? this.clickHiddenButton(e) : null}>View Details</button>
                                )
                            }
                        </span>
                    );
                }
            }

            // if image is link then wrap it in anchor "a" element
            if (isImageLink) {
                $.extend(style, {
                    cursor: 'default'
                });

                if ( _.isEmpty(imageTemplateString) ) {
                    imageTemplateString = (
                        <span className={spanClass} style={StyleTransfrom(spanStyle)}>
                            <img
                                 style={StyleTransfrom(style)} src={image}
                                 className="x-rsch-drawing imageWrapper"
                                 alt={altText} aria-label={altText} />
                        </span>
                        );
                }

                const link = getHref(model[imageSize].href);
                const linkedImageStyleBlock = isNonResearchIconImage ? '' : 'display:block;';
                let aTarget: any = {
                    target: '_blank'
                  };
                if (HTML_RENDITION.isCompendiumProduct()) {
                    aTarget = {};
                }
                let aImgLink: any = (<a tabIndex={0} href={link} {...aTarget}> {imageTemplateString} </a>);
                // Important!!! in here We can add more if else logic to judge class and return a react components.
                if (spanClass.indexOf('InfographicConversionFlag') >= 0) {
                    aImgLink = null;
                    imageTemplateString = (<span className={spanClass}
                        style={StyleTransfrom(linkedImageStyleBlock + "overflow-x:auto;overflow-y:hidden;")}>
                        <InfographicTemplate source={source} />
                        </span>);
                } else if (spanClass.indexOf('SupplyChainConversionFlag') >= 0) {
                    element.addClass('supplyChainInBody')
                        .parent('p').addClass('supplyChainSelectedCompanies')
                        .find('span').wrapAll('<a aria-label="supply chain link" role="link" className="supplyChainLinkInBody"></a>');
                    element.parents('p')
                        .on('click', (e) => switchPage('supplyChainCompanyListPage'));
                    imageTemplateString = (<span className={spanClass} style={StyleTransfrom(spanStyle)}>
                        <img tabIndex={0} role="img" className="x-rsch-drawing imageWrapper" src={image} alt={altText} aria-label={altText} />
                    </span>);
                } else {
                    imageTemplateString = (<span className={spanClass}
                        style={StyleTransfrom(linkedImageStyleBlock + "overflow-x:auto;overflow-y:hidden;")}>
                        {aImgLink}
                    </span>);
                }
            }
            this.setState({
                finalElement: imageTemplateString
            });
        }
    }

    public openGallery(e: any) {
        const currentTarget = $(e.currentTarget);
        let tableTpl: any = null;
        let _modalTitle = null;
        let figureGalleryDom: any = null;
        let _modalSource: any = null;
        if (currentTarget.parents('.image-table').length) {
            // below logic is open figure gallery
            _modalTitle = this.props.docHeaderJsonData.i18n.figure_gallery;
            const targetImgName = ($(e.target) as any).attr('src').toLowerCase().split('images/')[1].split('?')[0];
            figureGalleryDom = <ErrorBoundary><FigureGalleryDom targetName={targetImgName} /></ErrorBoundary>;
            window.HTML_RENDITION.openDetachURL = HTML_RENDITION.getDetachUrl("figureGallery", _modalTitle);
        } else if (currentTarget.hasClass('rendition_zoom_image')) {
            tableTpl = currentTarget.clone();
        }
        if (figureGalleryDom) {
            _modalSource = figureGalleryDom;
        } else if (tableTpl) {
            _modalSource = tableTpl.prop("outerHTML");
        } else {
            _modalSource = null;
        }
        this.setState({
            modalSource: _modalSource,
            modalTitle: _modalTitle
        });
    }

    public openEnlargedImage(e: any, register: string) {

        const conditionsToModifyFullSpan = (!register ||
                                            $(e.currentTarget).parents('.modalWindow').length ||
                                            $(e.currentTarget).parents('.ReactModal__Content').length ||
                                            $(e.currentTarget).parents('.detach-figure-gallery-container').length) &&
                                            $(e.currentTarget).hasClass('rendition_zoom_image') &&
                                            this.props.initialData.enable_figure_zoom;
        if (conditionsToModifyFullSpan) {
            $(e.currentTarget).hasClass('full-span') ?
                $(e.currentTarget).removeClass('full-span') :
                $(e.currentTarget).addClass('full-span');
            this.stopBubbling(e);
            return;
        }
        if (!_.isEmpty(this.props.figureGalleryData) && !HTML_RENDITION.isCompendiumProduct()) {
            this.openGallery(e);
        }else{
            this.setState({
                modalSource: (<div style={{padding: "30px"}}>
                                <img tabIndex={0} role="button" aria-label={'Open modal - ' + this.state.modalTitle} src={e.target.src} alt="drawing image"/>
                             </div>)
            });
        }
    }

    public openModal(e: any) {
        if (HTML_RENDITION.isPresentation()) return;

        if ($(e.currentTarget).parents('.modalWindow').length) {
            return;
        }
        // Important!!! the close modal action can through bubbling propagation to here, So that we can set the status again!
        // Improtant!!! you must setState in below if else to avoid cause reRender!
        if (e.target.id === "modalClose" || e.target.id === "figureGalleryScrollTo" ||
                e.currentTarget.classList.contains('supplyChainInBody') ||  // if it's a supplychain, the modal should not be opened
                !_.isUndefined($(e.currentTarget).find('a').attr('href')     // if there's a link, the modal should not be opened
            )) {
            // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
                modalTitle: null,
                modalSource: null   // need to clear modal data when close the modal
            });
            $('.triggered_popup_flag').first().focus();
            $('.triggered_popup_flag').removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            this.setState({
                modalStatus: true,
            });
            e.target.className += " triggered_popup_flag";
        }
        // Important!!! Avoid the open modal action through bubbling propagation to CitiTableTemplate open again!
        this.stopBubbling(e);
    }

    public figureGalleryWindowStyle () {
        const initialStyle = {width: '1233px',  background: 'transparent', height: '850px', left: '25px', marginTop: '20px'};
        let finalStyle = {};
        let deviceScreenStyle = {};
        let height = '';
        let width = '';
        if (deviceInfoService.isDeviceScreenType()) {
            height = `${window.innerHeight - 85}px`;
            width = `${window.innerWidth}px`;
            deviceScreenStyle = {left: 0, top: '65px', zIndex: 1050, position: 'fixed', marginTop: 0, height, width};
        } else {
            const mainPageWidth = document.getElementById('mainPage')?.offsetWidth || 0;
            height = `${window.innerHeight - 105}px`;
            width = `${mainPageWidth - 45}px`;
            deviceScreenStyle = {top: 0, bottom: 0, position: 'relative', height, width};
        }
        finalStyle = {...initialStyle, ...deviceScreenStyle};
        return finalStyle;
    }

    public figureGalleryBodyStyle () {
        const initialStyle = { overflow: 'initial' };
        let finalStyle = {};
        let deviceScreenStyle = {};
        if (deviceInfoService.isDeviceScreenType()) {
            deviceScreenStyle = {height: `${window.innerHeight - 85 - 27}px`};
        } else {
            deviceScreenStyle = {height: `${window.innerHeight - 105 - 27}px`};
        }
        finalStyle = {...initialStyle, ...deviceScreenStyle};
        return finalStyle;
    }

    public loadMagnifierBranding() {
        let Branding: any;
    
        if (showOldBranding) {
          Branding = RenditionLoadable({
            loader: () => import('../../dynamicComponents/magnifierOld'),
          }, 'magnifierOld', Date.now());
        }
        else {
          Branding = RenditionLoadable({
            loader: () => import('../../dynamicComponents/magnifierNew'),
          }, 'magnifierNew', Date.now());
        }
    
        return <Branding/>;
      }

    public render() {
        const _modalStatus = this.state.modalStatus;
        const _modalSource = this.state.modalSource;
        if (window.HTML_RENDITION.lastDrawingTemplates && !this.props.altText){
            window.HTML_RENDITION.lastDrawingTemplates.push(this);
        }

        return (
            <span className="drawing-template-part" ref={this.drawingRef}
                onClick={(e) => this.openModal(e)}
                onKeyPress={(e) => (e.keyCode === 13 || e.keyCode === 32 || e.which === 13 || e.which === 32) ? this.openModal(e) : null}>
                {this.loadMagnifierBranding()}
                {_modalStatus && _modalSource && this.state.modalTitle &&
                (<ModalPopup classList={"modal-gallery"}>
                    <NormalScreenPopup
                        titleSource={this.state.modalTitle} bodySource={_modalSource}
                        modalWindowStyle={this.figureGalleryWindowStyle()}
                        modalBodyStyle={this.figureGalleryBodyStyle()} openDetachURL={'true'} showCopy={isFigureGalleryPopup(this.state.modalTitle, this.props.docHeaderJsonData.i18n.figure_gallery)} />
                </ModalPopup>)}
                {_modalStatus && _modalSource && !this.state.modalTitle &&
                (<ModalPopup classList={"modal-enlarged-image"}>
                    <ImageEnlargePopup bodySource={_modalSource}/>
                </ModalPopup>)}
                {this.state.finalElement}
            </span>
        );
    }

    private stopBubbling(e: any) {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            (window as any).event.cancelBubble = true;
        }
    }

    private clickHiddenButton(e: any) {
        e.target.previousSibling?.click();
    }

    private handleClassList(originalMaxWidth: number, imgWidth: number, imgRef: any) {
        if (this.props.initialData.enable_figure_zoom && (originalMaxWidth > imgWidth) &&
            this.props.initialData.enable_figure_full_span) {
                imgRef?.classList.add('full-span');
        } else {
            imgRef?.classList.remove('rendition_zoom_image');
        }
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        screenType: state.commonStateReducer.screenType,
        imageSizeCategory: state.commonStateReducer.imageSizeCategory,
        initialData: state.asyncStateReducer.initialData,
        docHeaderJsonData: state.asyncStateReducer.docHeaderJsonData,
        figureGalleryData: state.asyncStateReducer.figureGalleryData,
    };
};

export default connect(mapStateToProps)(DrawingTemplate);
